import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'dynamicWidgetList',
    label: 'Dynamic Widget List',
    builderInitialValues,
    builder: Builder,
    player: Player,
    noBuilderBlock: true,
};
